import { render } from "./ResourceMultiselect.vue?vue&type=template&id=867cbee4"
import script from "./ResourceMultiselect.vue?vue&type=script&lang=js"
export * from "./ResourceMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__